import React from 'react';
import AboutSectionSouth from './AboutSectionSouth';  // Updated import name

const AboutPageSouth = () => {  // Updated component name
  return <AboutSectionSouth />;
};

export default AboutPageSouth;
